/* Image-only thumbnail galleries do not need Swiper or ResizeObserver to work. */
(function () {
  function init(root) {
    root.querySelectorAll('.product__outer--thumbs-aside .js-media-list').forEach(function (gallery) {
      var outer = gallery.closest('.product__outer');
      var thumbs = outer.querySelector('.js-media-sublist');
      var slides = Array.from(gallery.querySelectorAll('.product__media-item'));
      var items = thumbs ? Array.from(thumbs.querySelectorAll('.product__media-subitem')) : [];
      if (!slides.length || items.length !== slides.length || slides.some(function (s) { return s.querySelector('video, model-viewer, deferred-media'); })) return;
      if (gallery.swiper) gallery.swiper.destroy(true, true);
      if (thumbs.swiper) thumbs.swiper.destroy(true, true);
      gallery.classList.remove('js-media-list', 'swiper');
      thumbs.classList.remove('js-media-sublist', 'swiper');
      gallery.classList.add('sfp-image-gallery');
      thumbs.classList.add('sfp-image-thumbs');
      var current = Math.max(0, Math.min(slides.length - 1, Number(gallery.dataset.currentIndex) || 0));
      var prev = gallery.querySelector('.swiper-button-prev');
      var next = gallery.querySelector('.swiper-button-next');
      function show(index, focus) {
        current = Math.max(0, Math.min(slides.length - 1, index));
        gallery.dataset.currentIndex = current;
        slides.forEach(function (slide, i) { slide.hidden = i !== current; });
        items.forEach(function (item, i) {
          item.classList.toggle('swiper-slide-thumb-active', i === current);
          item.setAttribute('aria-pressed', String(i === current));
          item.tabIndex = i === current ? 0 : -1;
        });
        if (prev) { prev.disabled = current === 0; prev.setAttribute('aria-disabled', String(prev.disabled)); prev.classList.toggle('swiper-button-disabled', prev.disabled); }
        if (next) { next.disabled = current === slides.length - 1; next.setAttribute('aria-disabled', String(next.disabled)); next.classList.toggle('swiper-button-disabled', next.disabled); }
        if (focus) items[current].focus({preventScroll:true});
      }
      slides.forEach(function (slide) { slide.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; }); });
      items.forEach(function (item, i) {
        item.setAttribute('role', 'button'); item.setAttribute('aria-label', 'View product image ' + (i + 1) + ' of ' + slides.length);
        item.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
        item.addEventListener('click', function () { show(i); });
        item.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); show(i); }
          else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { event.preventDefault(); show(current + 1, true); }
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') { event.preventDefault(); show(current - 1, true); }
        });
      });
      if (prev) prev.addEventListener('click', function (event) { event.preventDefault(); show(current - 1); });
      if (next) next.addEventListener('click', function (event) { event.preventDefault(); show(current + 1); });
      var start;
      gallery.addEventListener('click', function (event) {
        if (!event.target.closest('.product__media-toggle')) return;
        var modal = document.querySelector('.js-popup-slider');
        if (modal && modal.swiper) modal.swiper.slideTo(current, 0);
      }, true);
      gallery.addEventListener('touchstart', function (event) { start = event.touches[0]; }, {passive:true});
      gallery.addEventListener('touchend', function (event) {
        if (!start) return;
        var end = event.changedTouches[0], dx = end.clientX - start.clientX, dy = end.clientY - start.clientY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
        start = null;
      }, {passive:true});
      show(current);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  new MutationObserver(function (records) {
    if (records.some(function (record) { return Array.from(record.addedNodes).some(function (node) { return node.nodeType === 1 && (node.matches('.js-media-list') || node.querySelector('.js-media-list')); }); })) init(document);
  }).observe(document.body, {childList:true, subtree:true});
})();
